import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Navlink from './Navlink';
import './Navbar.css';

export default class Navbar extends Component {

    state = {
        pages: ["watches", "applications", "contact", "about"],
        menuOpen: false
    }

    componentWillReceiveProps(nextProps) {
        this.closeMenu();
    }

    toggleMenu = () => {
        var navbar = document.getElementById("nav-container");
        if (navbar.className === "") {
            this.openMenu();
        } else {
            this.closeMenu();
        }
    }

    openMenu = () => {
        var navbar = document.getElementById("nav-container");
        if (navbar.className === "") {
            navbar.className = "open-menu-nav";
            this.setState({
                menuOpen: true
            });
        }
    }

    closeMenu = () => {
        var navbar = document.getElementById("nav-container");
        if (navbar.className !== "") {
            navbar.className = "";
            this.setState({
                menuOpen: false
            });
        }
    }

    render() {
        return (
            <div id="nav-container">
                <Link to="/"><span className="logo">Evan Simon Ross</span></Link>
                <div id="menu" className="navlink">
                    <i className="fa fa-bars" onClick={this.toggleMenu} />
                </div>
                {
                    this.state.pages.map((p, i) =>
                        <Navlink key={i} page={p} active={this.props.page === p ? true : false} />
                    )
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js